/**
 * Drempels voor het signaleren van verdachte invullingen in de diepte-analyse.
 *
 * Eén plek, want een drempel die op twee plaatsen staat gaat afwijken zodra
 * iemand er één aanpast — en beide kanten houden dan groene tests.
 * AI-CONTEXT: See docs/pitfalls.md#dev-mirrored-constant-guarded-only-by-a-comment
 *
 * @type {{MIN_ROWS: number, CONTROL_GAP: number, OUTLIER_MAD_FACTOR: number, OUTLIER_MIN_SUBMISSIONS: number, OUTLIER_MIN_MAD: number}}
 */
const SUSPECT_THRESHOLDS = {
    // Minder dan drie rijen is geen patroon maar toeval.
    MIN_ROWS: 3,
    // Verschil in punten tussen de gespiegelde controlevraag en het gemiddelde
    // van de overige rijen waarboven de invulling zichzelf tegenspreekt.
    //
    // 3,5 en niet 3. Gemeten over alle 4.961 toetsbare invullingen (2026-09-22):
    // bij >= 3 punten vuurt hij op 5,2%, bij >= 3,5 op 1,4%, bij >= 4 op niets.
    // Die 3-punts-gevallen zijn vaak plausibele profielen in plaats van
    // tegenspraak: een matrix mengt deelvaardigheden, dus "ik begrijp geen
    // teksten" (1) naast "ik spreek niet slecht Nederlands" (oneens) is geen
    // fout maar iemand die wel spreekt en niet leest. De controlevraag
    // spiegelt maar één van de rijen echt, niet het gemiddelde van alle.
    CONTROL_GAP: 3.5,
    // Hoeveel mediane absolute afwijkingen van de mediaan een invulling moet
    // liggen om een uitschieter te heten.
    OUTLIER_MAD_FACTOR: 3,
    // Onder dit aantal invullingen is 'ver van de rest' betekenisloos
    // (besluit Gijs 2026-09-22: méér dan 10, dus vanaf 11).
    OUTLIER_MIN_SUBMISSIONS: 11,
    // Ondergrens op de spreiding. Antwoorden zijn hele getallen op een korte
    // schaal, dus een groep kan precies dezelfde score hebben — dan is de
    // mediane absolute afwijking 0 en zou élk verschil een uitschieter heten,
    // of (met een vroege return) juist géén enkel. Beide zijn fout. Met deze
    // ondergrens moet een invulling bij een perfect uniforme groep minimaal
    // 3 × 0,25 = 0,75 punt afwijken.
    OUTLIER_MIN_MAD: 0.25,
};

export default SUSPECT_THRESHOLDS;
